"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoreOptionsButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const MoreOptionsIcon_1 = require("../../../icons/MoreOptionsIcon");
const IconButton_1 = require("../IconButton");
const MoreOptionsButton_module_css_1 = __importDefault(require("./MoreOptionsButton.module.css"));
/**
 * Kebab menu icon button
 */
function MoreOptionsButton({ onClick }) {
    return ((0, jsx_runtime_1.jsx)("div", { className: MoreOptionsButton_module_css_1.default.moreOptionsButton, children: (0, jsx_runtime_1.jsx)(IconButton_1.IconButton, { size: "SMALL", onClick: onClick, label: "Toggle More Options", children: (0, jsx_runtime_1.jsx)(MoreOptionsIcon_1.MoreOptionsIcon, { size: "LARGE" }) }) }));
}
exports.MoreOptionsButton = MoreOptionsButton;
//# sourceMappingURL=MoreOptionsButton.js.map